export class PMOTeamGridViewModel {
    constructor() {
        this.teamId = "";
        this.teamName = "";
        this.teamLeadName = "";
        this.teamLeadImageURL = "";
        this.teamMembersCount = "";
        this.memberImageURLs = [];
        this.memberNames = [];
        this.projectsCount = "";
        this.isActive = false;
        this.deactivatedOn = null;
        this.deactivatedReason = null;
    }
}
export default class PMOTeamGridView extends PMOTeamGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
